import globals from '../../common/globals';
import SlidesTakeAction from '../vx-campaign-brawny-takes-action/vx-campaign-brawny-takes-action-slides/vx-campaign-brawny-takes-action-slides.vue';

export default {
  name: 'vx-campaign-brawny-takes-action',
  data() {
    return {
      globals,

      currentIndex: 0,
    };
  },
  components: {
    'vx-campaign-brawny-takes-action-slides': SlidesTakeAction,
  },
  props: {
    slideDataBta: {
      type: Object,
      default: {},
    },
  },
  methods: {
    next() {
      this.currentIndex += 1;
      if (this.slideDataBta && this.currentIndex > this.slideDataBta.slider.length - 1) {
        this.currentIndex = 0;
      }
    },
    prev() {
      this.currentIndex -= 1;
      if (this.slideDataBta && this.currentIndex < 0) {
        this.currentIndex = this.slideDataBta.slider.length - 1;
      }
    },
    icon(ind) {
      this.currentIndex = ind;
    },
    activeClass(ind) {
      return this.currentIndex === ind;
    },
  },
  computed: {
    currentSlider() {
      if (this.slideDataBta) {
        return this.slideDataBta.slider[Math.abs(this.currentIndex) % this.slideDataBta.slider.length];
      }
      return 0;
    },

  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-brawny-takes-action/vx-campaign-brawny-takes-action.js